import { useEffect } from "react";
import { X } from "lucide-react";

const ConfirmModal = ({
  isOpen = true,
  title = "Confirm Action",
  message,
  onClose,
  onConfirm,
  confirmLabel = "Yes, Proceed.",
  cancelLabel = "Cancel"
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    return () => document.body.classList.remove("no-scroll");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50">
      <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold">{title}</h2>
          <button onClick={onClose}>
            <X className="text-gray-600 hover:text-red-500" />
          </button>
        </div>
        <p className="text-gray-700 mb-6">{message}</p>
        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 rounded-full hover:bg-gray-400 text-sm"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm} // <- Let parent close modal after confirm
            className="px-4 py-2 bg-red-500 text-white rounded-full hover:bg-red-600 text-sm"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
